export const SET_SIMPLE_FLOW_DIAGNOSIS = "simpleFlow/SET_SIMPLE_FLOW_DIAGNOSIS"
export const SET_CARDINAL_RESPONSES = "simpleFlow/SET_CARDINAL_RESPONSES"
export const SET_CARDINAL_EVIDENCE = "simpleFlow/SET_CARDINAL_EVIDENCE"
export const SET_SIMPLE_FLOW_ACTIVE = "simpleFlow/SET_SIMPLE_FLOW_ACTIVE"
export const SHIFT_CARDINAL_RESPONSES = "simpleFlow/SHIFT_CARDINAL_RESPONSES"
export const SET_CARDINAL_SUBMITTED = "simpleFlow/SET_CARDINAL_SUBMITTED"



// WEBPACK FOOTER //
// ./assets/simpleFlow/actionTypes.js